import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useToken } from "../TokenContext";
import { useExamStatus } from "./ExamStatusContext";
import "../../css/GATBresults.css";
import thanksSound from "../../voice/GATBresult.wav";

const GATBresults = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { examStatus, setExamStatus } = useExamStatus();
  const { companyName_findjob } = useToken();

  const [hasCalling, setHasCalling] = useState(null);

  // 拠点名を取得（locationNamesを優先、なければcompanyName_findjob）
  const locationNamesStr = localStorage.getItem("locationNames");
  let affiliation = null;
  if (locationNamesStr) {
    try {
      const locationNames = JSON.parse(locationNamesStr);
      if (Array.isArray(locationNames) && locationNames.length > 0) {
        affiliation = locationNames.join('、'); // 複数拠点の場合は「、」で結合
      } else if (typeof locationNames === 'string') {
        affiliation = locationNames;
      }
    } catch (e) {
      // JSON解析に失敗した場合は文字列として扱う
      affiliation = locationNamesStr;
    }
  }
  
  // 拠点名が取得できない場合は企業名をフォールバック
  if (!affiliation) {
    affiliation = localStorage.getItem("companyName_findjob");
  }
  
  const interestScores = localStorage.getItem("interestScores");

  const loading = hasCalling === null;
  const showConsultant = hasCalling;
  const buttonLabel = showConsultant
    ? "コンサルタントページへ"
    : "興味分野診断を受ける";

  const defaultJudgement = {
    G: "未評価",
    V: "未評価",
    N: "未評価",
    Q: "未評価",
    S: "未評価",
    P: "未評価",
  };

  const {
    url: signedUrl,
    job_suggestions: suggestions = [],
    judgement: rawJudgement = {},
  } = location.state || {};

  const judgement = { ...defaultJudgement, ...rawJudgement };

  useEffect(() => {
    const audio = new Audio(thanksSound);
    audio.play().catch((error) => {
      console.error("自動再生に失敗しました:", error);
    });
  }, []);

  useEffect(() => {
    if (examStatus === "検査中") {
      setExamStatus("検査前");
    }
  }, [examStatus, setExamStatus]);

  useEffect(() => {
    try {
      const isValid =
        Object.keys(rawJudgement).length > 0 &&
        Object.values(rawJudgement).some((val) => val !== "未評価");

      if (isValid) {
        localStorage.setItem("gatbJudgement", JSON.stringify(judgement));
      } else {
        console.warn("GATB判定が空か全て未評価のため保存しません:", judgement);
      }
    } catch (e) {
      console.error("localStorage保存に失敗しました", e);
    }
  }, [judgement]);

  useEffect(() => {
    const loginCode = localStorage.getItem("loggedInToken");
    if (!loginCode) return;
      fetch("https://mpzzlvohx7.execute-api.ap-northeast-3.amazonaws.com/prod/api/checkAttended", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ loginCode, type: "calling" }),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("該当タイプの検査結果:", data.exists);
          setHasCalling(data.exists);
      })
        .catch((err) => {
          console.error("興味分野診断判定確認エラー:", err);
        });
  }, []);

  const fields = [
    { name: "知的 (G)", key: "G" },
    { name: "言語 (V)", key: "V" },
    { name: "数理 (N)", key: "N" },
    { name: "空間 (Q)", key: "Q" },
    { name: "形態 (S)", key: "S" },
    { name: "書記 (P)", key: "P" },
  ];

  const renderWithBold = (text) => {
    if (!text) return null;
    const parts = text.split(/(\*\*.+?\*\*)/);
    return parts.map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      return part;
    });
  };

  return (
    <div className="gatb-results-container">
      <h1>
        {renderWithBold(
          `GATB 結果ページ - ${localStorage.getItem("userName") || "試験者"}さん（所属：${companyName_findjob || "未設定"}）`
        )}
      </h1>

      <div>
        <h2>PDFダウンロード:</h2>
        {signedUrl ? (
          <a
            href={signedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="pdf-download-link"
          >
            結果PDFをダウンロード
          </a>
        ) : (
          <p>PDFリンクがありません。</p>
        )}
      </div>

      <h2>スコア評価:</h2>
      <div className="judgement-grid">
        {fields.map((field) => (
          <div key={field.key}>
            <strong>{field.name}</strong>
            {judgement[field.key] || "未評価"}
          </div>
        ))}
      </div>

      <h2>提案された適職リスト:</h2>
      {suggestions.length > 0 ? (
        <ul className="job-suggestions-list">
          {suggestions.map((job, index) => {
            const address = localStorage.getItem("userAddress") || "日本";
            const normalizedJob = job.replace(/\u3000/g, " ").trim();
            const isNumbered = /^\d+\.\s/.test(normalizedJob);
            const base = job
              .replace(/\*\*/g, "")
              .split("-")[0]
              .replace(/^\d+\.\s*/, "")
              .trim();
            const matches = base.match(/（(.+?)）/g);
            const industry = matches
              ? matches.map((m) => m.replace(/[（）]/g, "")).join(" ")
              : "";
            const cleanJob = base.replace(/[（）]/g, " ").replace(/\s+/g, " ").trim();
            const searchQuery = `${address} ${cleanJob} ${industry} "求人"`.trim();

            return (
              <li key={index} className="job-item">
                <span className="job-title">{renderWithBold(job)}</span>
                {isNumbered && (
                  <button
                    className="job-search-button"
                    onClick={() =>
                      window.open(
                        `https://www.google.com/maps/search/${encodeURIComponent(searchQuery)}`,
                        "_blank",
                        "noopener noreferrer"
                      )
                    }
                  >
                    Googleで探す
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        <p>提案された適職はありません。</p>
      )}

      <div className="button-group">
        {loading ? (
          <p>診断チェック中...</p>
        ) : (
          <>
            <button
              className="go-to-consultant-button"
              onClick={() => {
                const userName = localStorage.getItem("userName");
                if (showConsultant) {
                  navigate("/consultant", {
                    state: {
                      userName,
                      affiliation,
                    },
                  });
                } else {
                  navigate("/Questionnaire");
                }
              }}
            >
              {buttonLabel}
            </button>
            <button
              className="return-to-portal-button"
              onClick={() => navigate("/Portal")}
            >
              ポータルページへ
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default GATBresults;
